import DataManager from "react-sdk/haxelibs/DataManager"
import { succubus_data_DataFile } from "react-sdk/haxelibs/datamanagertypes.d.ts"
import AppState from "./AppState"
import Chapter from "./Chapter"




class Chapters {

  /** @type {Array<Chapter>} */
  all = []

  /**
   * 
   * @param {succubus_data_DataFile} dataFile 
   */
  init(filename) {
    let dataFile = DataManager.getFile(filename);
    this.all = dataFile.lines
      .filter(line => line.id)
      .map(line => new Chapter(line))
  }

  get ids() { return this.all.map(c => c.id)}


  get(id) { return this.all.filter(chapter => chapter.id === id)[0] }
  

  stateToJson() {
    return this.all.map(c => {
      return { id : c.id, stars : c.stars, inProgress : c.inProgress, finished : c.finished}
    })
  }
  stateFromJson(state) {
    if (state == null)
        return

    state.forEach(chapterState => { 
      let c = this.get(chapterState.id)
      if (c) {
        c.stars = chapterState.stars
        c.inProgress = chapterState.inProgress
        c.finished = chapterState.finished
      }
    })
  }

  

  

}


export default new Chapters()